<template>
  <div v-if="characterCount" class="char-counter">{{ characterCount }}</div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
export default defineComponent({
  name: 'CharCounter',
  props: {
    value: {
      type: String,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const characterCount = computed(() => {
      if (props.value?.length) {
        return `${props.max - props.value.length}`;
      } else {
        return null;
      }
    });
    return {
      characterCount,
    };
  },
});
</script>
<style scoped lang="scss" src="./char-counter.scss" />
